export default __webpack_public_path__ + "static/media/zrogowacenia2.7a03c2d5.jpg";